<div fxLayout="column" class="resource-table">
  <div
    fxLayout="row wrap"
    fxLayoutalign="start center"
    style="margin-bottom: 10px"
  >
    <!-- <div fxFlex="none">
      <mat-radio-group
        [(ngModel)]="viewMode"
        (change)="onViewModeChange($event)"
      >
        <mat-radio-button value="table" style="margin-right: 10px"
          >Table view</mat-radio-button
        >
        <mat-radio-button value="tree">Tree view</mat-radio-button>
      </mat-radio-group>
    </div> -->
    <div
      *ngIf="viewMode === 'table'"
      fxFlex="none"
      fxLayout="row"
      fxLayoutAlign="start center"
    >
      <mat-radio-group
        [(ngModel)]="eventMode"
        (change)="onEventModeChange($event)"
      >
        <mat-radio-button value="resource" style="margin-right: 10px">{{
          'key_resourceEvents' | translate
        }}</mat-radio-button>
        <mat-radio-button value="request">{{
          'key_requestEvents' | translate
        }}</mat-radio-button>
      </mat-radio-group>
    </div>
    <div
      *ngIf="viewMode === 'table'"
      style="margin-left: 60px; margin-top: 6px"
    >
      <mat-slide-toggle
        [(ngModel)]="includeArchiev"
        (change)="onIncludeArchievChange()"
        >{{ 'key_includeArchive' | translate }}</mat-slide-toggle
      >
    </div>
    <div
      *ngIf="viewMode === 'table'"
      style="margin-left: 20px; margin-top: 6px; margin-right: 60px"
    >
      <mat-slide-toggle
        [(ngModel)]="includeSystemEvents"
        (change)="onIncludeSystemEvents()"
        >{{ 'key_includeSystemEvents' | translate }}</mat-slide-toggle
      >
    </div>
    <app-attribute-picker
      #attrPicker
      *ngIf="viewMode === 'table'"
      fxFlex="auto"
      [appearance]="'outline'"
      [objectType]="'event'"
      [multiple]="true"
      [preSelectedItems]="selectedAttributes"
      (attributeChange)="onAttributeChange($event)"
      style="margin: -5px 60px 0 0"
    ></app-attribute-picker>
    <div
      *ngIf="viewMode === 'table'"
      fxFlex="none"
      fxLayout="row"
      fxLayoutAlign="start center"
      style="margin-top: -6px"
    >
      <button mat-flat-button style="margin-left: 20px" (click)="onRefresh()">
        <div fxLayout="row" fxLayoutAlign="center center">
          <span
            class="material-icons-outlined primary-color"
            style="margin-right: 10px"
            >refresh</span
          >
          <div style="font-weight: 400">
            {{ 'key_refresh' | translate }}
          </div>
        </div>
      </button>
    </div>
  </div>
  <app-resource-table
    #resourceTable
    *ngIf="viewMode === 'table'"
    [config]="tableConfig"
  ></app-resource-table>
  <!-- <app-resource-table
    #resourceTable
    *ngIf="viewMode === 'table'"
    [config]="tableConfig"
    [adjustApiData]="adjustEventData"
    [adjustApiPageSize]="adjustEventPageSize"
    [adjustApiStateChange]="adjustEventStateChange"
  ></app-resource-table> -->
  <app-tree-list
    *ngIf="viewMode === 'tree'"
    [config]="treeListConfig"
    [adjustRootApiData]="adjustTreeListData"
    [adjustChildrenApiData]="adjustTreeListData"
  ></app-tree-list>
</div>
